import { authorizedGet } from "../scripts/functions/AuthService";

export const getStatus = (budget) => {
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);

    if (budget.startDate) {
        const startDate = new Date(budget.startDate);
        startDate.setHours(0, 0, 0, 0);

        if (startDate.getTime() <= currentDate.getTime()) {
            return "Ingresado"
        }
    }

    const priceFields = [
        budget.authQuantity, budget.unitPrice, budget.dieCutPrice, 
        budget.urgencyPrice, budget.total
    ]

    const isPresupuestado = priceFields.every(field => field !== "" && field !== null && field !== undefined);

    if (isPresupuestado && budget.status !== "Ingresado" && budget.approved) {
        return "Presupuestado";
    }

    if (budget.status === "Borrador") {
        return "Presupuestar";
    }

    // console.log("Estado: ", budget.status);
    return budget.status;
}

export const cleanBudget = (data) => {
    return Object.keys(data).reduce((acc, key) => {
        const value = data[key];
        if (value !== "" && value !== null) {
            acc[key] = value;
        }
        return acc;
    }, {});
}

export const getFiles = async (budget) => {
    try {
        const encodedBudget = encodeURIComponent(budget);
        const response = await authorizedGet(`/budget/getFiles/${encodedBudget}`)
        const resData = await response.body.json();

        // console.log("Presupuesto: ", resData);
        return resData;
    } catch (error) {
        console.error("Error fetching files:", error);
        return null;
    } 
}